<template>
  <div>
    <el-carousel
      :interval="4000"
      height="430px"
      :autoplay="autoplay"
      arrow="never"
      ref="previewCarousel"
      @change="onPageChange"
    >
      <el-carousel-item name="fl-finapp">
        <y-fl-finapp />
      </el-carousel-item>
      <el-carousel-item name="comp-buttons">
        <y-comp-buttons />
      </el-carousel-item>
      <el-carousel-item name="comp-menus">
        <y-comp-menus />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import FLFinapp from '../fastlink/flLayout.vue'
import CompButtons from '../cssComponents/buttons.vue'
import CompMenus from '../cssComponents/menus.vue'
export default {
  components: {
    'y-fl-finapp': FLFinapp,
    'y-comp-buttons': CompButtons,
    'y-comp-menus': CompMenus
  },
  props: {},
  data() {
    return {
      autoplay: false
    }
  },
  created() {
    this.$root.$on('changePreviewPage', pageName =>
      this.changeCarousel(pageName)
    )
  },
  computed: {},
  methods: {
    changeCarousel(previewPageName) {
      if (this.$refs.previewCarousel) {
        this.$refs.previewCarousel.setActiveItem(previewPageName)
      }
    },
    onPageChange(newSlide, oldSlide) {
      this.$store.state.custAppStore.tipsVisible = false
    }
  }
}
</script>

<style>
.el-carousel__indicators {
  display: none;
}
.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}
</style>
